import React, { useState, useCallback } from 'react'
import { Box, Heading, Text, Stack, ImageIcon } from '@/components/lib'

const EmptyBox = props => {
  const [isDragOver, setIsDragOver] = useState(false)

  const handleDragOver = useCallback((e) => {
    if (!props.onDrop) return
    e.preventDefault()
    setIsDragOver(true)
  }, [])
  const handleDragLeave = useCallback((e) => {
    if (!props.onDrop) return
    e.preventDefault()
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false)
    }
  }, [])
  const handleDrop = useCallback((e) => {
    if (!props.onDrop) return
    e.preventDefault()
    e.stopPropagation()
    setIsDragOver(false)
    props.onDrop(e)
  }, [])

  return (
    <Stack rounded='lg' p={10} m={5} gap={5} textAlign='center' {...props} bg={isDragOver ? 'bg.surface' : 'bg.subtle'} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} style={{ border: '2px dashed #ccc', cursor: props.onDrop ? 'pointer' : 'default' }}>
      {props.image &&
        <Box>
          <img alt={props.title} src={props.image} style={{ maxHeight: 250, maxWidth: 400, display: 'block', margin: '10px auto' }} />
        </Box>}
      {props.emptyCard &&
        <Stack direction='row' alignItems='center' justifyContent='center'>
          <Box textAlign='left'>
            {props.emptyCard}
          </Box>
        </Stack>}
      {props.icon &&
        <Stack direction='row' alignItems='center' justifyContent='center'>
          <ImageIcon title={props.title} iconKey={props.icon} />
        </Stack>}
      <Heading as='h3' size='md'>{props.title}</Heading>
      {props.description && <Text>{props.description}</Text>}
      {(props.children || props.action) && <Box>{props.children || props.action}</Box>}
    </Stack>
  )
}

export default EmptyBox
